const doc = [({"en":({"js":({"merfoto":({"order_lines":({"edit":({"submit_image_button":({"save_in_basket":"Save in basket"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;